import { Component, Vue } from "vue-property-decorator";
import { Blueprint, Product } from "../../models";
import { camelToUnderscore } from "../../utils/Typography";

@Component
export default class ProductsMixin extends Vue {
  readonly path = camelToUnderscore(Blueprint.type);
  readonly routes = this.$getModelRoutes(this.path);

  getBlueprints(data: any, tag) {
    return this.$httpGet(this.routes.indexUrl(data), tag);
  }

  getBlueprint(id: number | string, tag) {
    return this.$httpGet(this.routes.getUrl(id), tag);
  }

  destroyBlueprint(id, tag) {
    return this.$httpDelete(this.routes.deleteUrl(id), tag, null);
  }

  createBlueprint(data: any, tag) {
    return this.$httpPost(this.routes.createUrl(), tag, data);
  }

  updateBlueprint(id: string, data: any, tag) {
    return this.$httpPut(this.routes.updateUrl(id), tag, data);
  }

  detachFile(data: any, tag) {
    return this.$httpDelete(
      this.routes.getUrl(data.id) + "/attachments",
      tag,
      data
    );
  }
}
